var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-header", style: _vm.cssVars }, [
    _c("div", { staticClass: "mobile-header__inner" }, [
      _c("img", {
        staticClass: "mobile-header__logo",
        attrs: { src: _vm.logoImg, alt: "logo" },
        on: { click: _vm.goHome },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "mobile-header__search" }, [
        _c("img", {
          staticClass: "mobile-header__search-icon",
          attrs: { src: _vm.searchIcon, alt: "search" },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.keyword,
              expression: "keyword",
            },
          ],
          staticClass: "mobile-header__search-input",
          attrs: { type: "text", placeholder: "请输入您想要搜索的内容" },
          domProps: { value: _vm.keyword },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.handleSearch($event)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.keyword = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mobile-header__login", on: { click: _vm.handleLogin } },
        [
          !_vm.userInfo || !_vm.userInfo.userName
            ? [_vm._v("登录")]
            : [
                _c("img", {
                  staticClass: "mobile-header__avatar",
                  attrs: {
                    src: _vm.userInfo.userHd || _vm.defaultAvatar,
                    alt: "avatar",
                  },
                }),
              ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }